/**
 * Original code belongs to XD2Sketch/react-oauth-popup Repo. @link https://github.com/XD2Sketch/react-oauth-popup
 * This codebase has been converted and adjusted through ChatGPT to keep compatibility with our file system and codebase.
 */

import React, { useEffect, useState, useRef } from "react";

const createPopup = ({ url, title, width, height }) => {
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;
    return window.open(
        url,
        title,
        `width=${width},height=${height},left=${left},top=${top}`
    );
};

function OauthPopup({
    url,
    title = "",
    width = 500,
    height = 500,
    onCode,
    onClose,
    children,
}) {
    const [externalWindow, setExternalWindow] = useState(null);
    const intervalRef = useRef(null);

    const clearTimer = () => {
        if (intervalRef.current) {
            window.clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const onContainerClick = () => {
        if (!externalWindow || externalWindow.closed) {
            const newWindow = createPopup({ url, title, width, height });
            setExternalWindow(newWindow);
        }
    };

    useEffect(() => {
        if (externalWindow) {
            intervalRef.current = window.setInterval(() => {
                try {
                    // If user closed the popup manually
                    if (externalWindow.closed) {
                        clearTimer();
                        setExternalWindow(null);
                        onClose();
                        return;
                    }

                    const currentUrl = externalWindow.location.href;
                    const params = new URL(currentUrl).searchParams;
                    const code = params.get("code");
                    if (code) {
                        onCode(code, params);
                        clearTimer();
                        externalWindow.close();
                        setExternalWindow(null);
                    }
                } catch {
                    // Ignore cross-origin errors until popup redirects back to same origin
                }
            }, 700);
        }

        return () => {
            clearTimer();
            if (externalWindow && !externalWindow.closed) {
                externalWindow.close();
            }
        };
    }, [externalWindow, onCode, onClose]);

    return (
        <div onClick={onContainerClick} role="button" tabIndex={0}>
            {children}
        </div>
    );
}

export default OauthPopup;
